import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { AlertCardComponent } from './alert-card/alert-card.component';
import { SharedCardComponent } from './shared-card/shared-card.component';
import { EventsComponent } from './events/events.component';
import { SkeltonComponent } from './skelton/skelton.component';
import { CardSkeltonComponent } from './card-skelton/card-skelton.component';
import { NoResultsFoundComponent } from './no-results-found/no-results-found.component';
import { RouterModule } from '@angular/router';
import { SubHeaderComponent } from './sub-header/sub-header.component';
import { PaginationComponent } from './pagination/pagination.component';
import { SharedProfileComponent } from './shared-profile/shared-profile.component';
import { FilterComponent } from './filter/filter.component';
import { AppAutoComponent } from './app-auto/app-auto.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedAddressComponent } from './shared-address/shared-address.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { RenderImagePipe } from './pipes/renderImage.pipe';
import { PageNumber } from './pipes/pageNumber.pipe';



EventsComponent
@NgModule({
  declarations: [HeaderComponent, AlertCardComponent, SharedCardComponent, EventsComponent, SkeltonComponent, CardSkeltonComponent, NoResultsFoundComponent, SubHeaderComponent, PaginationComponent, SharedProfileComponent, FilterComponent, AppAutoComponent, SharedAddressComponent, RenderImagePipe, PageNumber],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,ReactiveFormsModule,SlickCarouselModule
  ],
  exports: [PageNumber, RenderImagePipe, SharedProfileComponent, PaginationComponent, HeaderComponent, AlertCardComponent, SharedCardComponent, EventsComponent, SkeltonComponent, CardSkeltonComponent, NoResultsFoundComponent, SubHeaderComponent, FilterComponent, AppAutoComponent,SharedAddressComponent],
})
export class SharedModule { }
